let PollBreak = 0;

(function PollForYotpoImgWidget() {
  if (document.querySelectorAll(".yotpo-pictures-widget div").length) {
    try {
      let elementLoad = document.querySelector(".yotpo-pictures-title-custom-container");
      elementLoad.classList.remove("d-none");
    } catch (error) {
      console.log(error);
    }
  } else if (++PollBreak < 50) {
    setTimeout(PollForYotpoImgWidget, 100);
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  const tabTitles = document.querySelectorAll(".tab-title");
  const tabContents = document.querySelectorAll(".review-tab-content");

  // Handle Tabs for Desktop
  tabTitles.forEach((title) => {
    title.addEventListener("click", () => {
      // Remove active classes
      tabTitles.forEach((t) => t.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Add active class to the clicked tab
      title.classList.add("active");
      const target = document.querySelector(title.dataset.target);
      target.classList.add("active");
    });
  });

  // Handle Accordion for Mobile
  tabContents.forEach((content) => {
    const header = content.querySelector("h3");
    header.addEventListener("click", () => {
      content.classList.toggle("active");
    });
  });

  function updateQuestionsCount() {
    // Find the count value element
    var yotpoTabSum = document.querySelector(".yotpo-header-summary");
    if (yotpoTabSum) {
      console.log("ques function executed");
      // Extract the numeric value from the text, removing parentheses
      var tabCountMatch = yotpoTabSum.textContent.match(/\d+/);
      var tabCount = tabCountMatch ? tabCountMatch[0] : 0;
      var questionsHeading = document.querySelector('.tab-title[data-target="#tab2"]');
      var questionsHeadingMobile = document.querySelector("#tab2.review-tab-content .accordion-title");
      // Update the heading to include the count
      if (questionsHeading) {
        if (parseInt(tabCount) > 0) {
          questionsHeading.innerHTML = `<span class="questions-text">Questions</span> <span class="question-count">${tabCount}</span>`;
          questionsHeadingMobile.innerHTML = `Questions <span class="question-count">${tabCount}</span>`;
        } else {
          questionsHeading.innerHTML = `Questions`;
        }
      }
    }
  }

  // MutationObserver to detect changes in the DOM
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // Check if the mutation is relevant (contains '.yotpo-header-summary')
      if (mutation.addedNodes.length) {
        var addedNodeArray = Array.from(mutation.addedNodes);
        var hasYotpoHeaderSummary = addedNodeArray.some(
          (node) => node.nodeType === 1 && node.querySelector(".yotpo-header-summary"),
        );
        if (hasYotpoHeaderSummary) {
          updateQuestionsCount();
        }
      }
    });
  });

  // Configuration of the observer
  var config = { childList: true, subtree: true };

  // Target node is the product accordion where Yotpo widget is likely to change the DOM
  var target = document.querySelector(".tabsAccordion");
  if (target) {
    observer.observe(target, config);
  }

  // Initial check in case the count is already available
  updateQuestionsCount();
});
